import React from 'react';

export function ANOVATable({ anovaTable, title, color = '#2980B9' }) {
  if (!anovaTable) return null;
  return (
    <div className="overflow-x-auto" data-testid="anova-table">
      {title && <h4 className="font-body mb-2" style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-dark)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</h4>}
      <table className="w-full text-xs border-collapse">
        <thead><tr style={{ backgroundColor: '#F0F7F3' }}>
          {['Source', 'DF', 'SS', 'MS', 'F', 'P', 'Sig'].map(h => (
            <th key={h} className="px-3 py-2 text-center font-body" style={{ fontSize: 12, fontWeight: 600, color: 'var(--green-900)', textTransform: 'uppercase' }}>{h}</th>
          ))}
        </tr></thead>
        <tbody>
          {Object.entries(anovaTable).map(([src, d], i) => (
            <tr key={src} className={i % 2 === 0 ? 'bg-white' : ''} style={i % 2 !== 0 ? { background: '#FAFAFA' } : {}}>
              <td className="px-3 py-2 font-body font-medium text-left" style={{ fontSize: 12 }}>{src}</td>
              <td className="px-3 py-2 text-center font-mono" style={{ fontSize: 12 }}>{d.DF ?? '-'}</td>
              <td className="px-3 py-2 text-center font-mono" style={{ fontSize: 12 }}>{typeof d.SS === 'number' ? d.SS.toFixed(4) : '-'}</td>
              <td className="px-3 py-2 text-center font-mono" style={{ fontSize: 12 }}>{typeof d.MS === 'number' ? d.MS.toFixed(4) : '-'}</td>
              <td className="px-3 py-2 text-center font-mono" style={{ fontSize: 12 }}>{typeof d.F === 'number' ? d.F.toFixed(4) : '-'}</td>
              <td className="px-3 py-2 text-center font-mono" style={{ fontSize: 12 }}>{typeof d.P === 'number' ? d.P.toFixed(6) : '-'}</td>
              <td className="px-3 py-2 text-center">
                {d.Sig && <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${d.Sig === '**' ? 'bg-emerald-500 text-white' : d.Sig === '*' ? 'bg-amber-500 text-white' : 'bg-gray-200 text-gray-600'}`}>{d.Sig}</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function KVTable({ data, title, color = '#2980B9' }) {
  if (!data || Object.keys(data).length === 0) return null;
  return (
    <div className="overflow-x-auto">
      {title && <h4 className="font-body mb-2" style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-dark)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</h4>}
      <table className="w-full text-xs border-collapse">
        <thead><tr style={{ backgroundColor: '#F0F7F3' }}>
          <th className="px-3 py-2 text-left font-body" style={{ fontSize: 12, fontWeight: 600, color: 'var(--green-900)' }}>Parameter</th>
          <th className="px-3 py-2 text-center font-body" style={{ fontSize: 12, fontWeight: 600, color: 'var(--green-900)' }}>Value</th>
        </tr></thead>
        <tbody>
          {Object.entries(data).map(([k, v], i) => (
            <tr key={k} className={i % 2 === 0 ? 'bg-white' : ''} style={i % 2 !== 0 ? { background: '#FAFAFA' } : {}}>
              <td className="px-3 py-1.5 font-body font-medium" style={{ fontSize: 12 }}>{k.replace(/_/g, ' ')}</td>
              <td className="px-3 py-1.5 text-center font-mono" style={{ fontSize: 12 }}>{typeof v === 'number' ? v.toFixed(4) : String(v)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ListAnovaTable({ anovaList, title }) {
  if (!anovaList || !Array.isArray(anovaList) || anovaList.length === 0) return null;
  const cols = Object.keys(anovaList[0]);
  return (
    <div className="overflow-x-auto" data-testid="list-anova-table">
      {title && <h4 className="font-body mb-2" style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-dark)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{title}</h4>}
      <table className="w-full text-xs border-collapse">
        <thead><tr style={{ backgroundColor: '#F0F7F3' }}>
          {cols.map(h => (
            <th key={h} className="px-3 py-2 text-center font-body" style={{ fontSize: 12, fontWeight: 600, color: 'var(--green-900)', textTransform: 'uppercase' }}>{h}</th>
          ))}
        </tr></thead>
        <tbody>
          {anovaList.map((row, i) => (
            <tr key={i} style={{ background: i % 2 !== 0 ? '#FAFAFA' : 'white' }}>
              {cols.map(col => (
                <td key={col} className="px-3 py-2 text-center" style={{ fontSize: 12 }}>
                  {col === 'Source' || col === 'Treatment' || col === 'Genotype' ? (
                    <span className="font-body font-medium text-left block">{row[col]}</span>
                  ) : col === 'Sig' && row[col] ? (
                    <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${row[col] === '**' ? 'bg-emerald-500 text-white' : row[col] === '*' ? 'bg-amber-500 text-white' : 'bg-gray-200 text-gray-600'}`}>{row[col]}</span>
                  ) : (
                    <span className="font-mono">{typeof row[col] === 'number' ? (Number.isInteger(row[col]) ? row[col] : row[col].toFixed(4)) : (row[col] ?? '-')}</span>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
